import { type SxProps } from '@mui/system'

export const cardStyles: SxProps = {
  borderRadius: '12px',
  width: '100%'
}

export const hierarchyOrgLabel: SxProps = {
  cursor: 'pointer',
  fontSize: '20px'
}

export const treeNodeLabel: SxProps = {
  cursor: 'pointer'
}

export const parentOrgsContainer: SxProps = {
  display: 'flex',
  marginBottom: '12px',
  alignItems: 'center'
}

export const childrenOrgsTreeView: SxProps = {
  flexGrow: 1,
  maxWidth: '80%',
  '& .MuiTreeItem-label': {
    fontSize: '18px'
  }
}

export const skeletonBlockStyles: SxProps = {
  width: '50vw',
  height: '13vh',
  marginBottom: '12px'
}

export const skeletonLineStyles: SxProps = {
  width: '80vw',
  height: '4vh',
  marginBottom: '12px'
}
